/**
 * Tech Check Route
 * Camera, microphone, and connection verification
 */
import { createFileRoute } from "@tanstack/react-router";
import { TechCheckPage } from "../pages/TechCheckPage";

export const Route = createFileRoute("/tech-check/$appointmentId")({
  component: TechCheckPage,
});
